export default __webpack_public_path__ + "static/media/ic-fruit-grapes.37f362bd.svg";